//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions, mapGetters } from 'vuex'
import { scroll } from 'quasar';
const { getScrollTarget, setScrollPosition } = scroll;
import { i18n } from '@/i18n';
import firebase from 'firebase/app'
// import '@firebase/messaging';
import 'firebase/firestore';
import 'boxicons';
export default {
  name:'app-article',
  data(){
    return{
      tokenFound:false,
      // token:"",
      imageError:false,
      paragraphs:[],
      date:'',
      youhealthful:"",
      title:"",
      id:"",
      article: {},
      views:false,
      // user:''
    }
  },
  methods: {
    i18n(key, args) {
      return i18n(key, args);
    },
     ...mapActions({
      navigation: 'layout/navigation',
      doFind: 'article/view/doFind',
      doUpdate: 'article/view/doUpdate'
    }),
  },
  computed:{
    ...mapGetters({
      record: 'article/view/record',
      token: 'layout/token'
    })
  },
  async mounted(){
    this.navigation('news')
    const ele = document.getElementById('article');
    const target = getScrollTarget(ele);
    const offset = ele.offsetTop-120;
    const duration = 0;
    setScrollPosition(target, offset, duration);
    // firebase.auth().signOut()
    if(!firebase.auth().currentUser){
      firebase.auth().signInAnonymously().then(async res => {
        const doc = await firebase.collection('article').doc(this.article.id).get()
        if(doc){
          let viewers = doc.data().viewers || []
          viewers = viewers.filter(I => I !== res.user.id)
          viewers.push(res.user.id)
          let views = viewers.length
          firebase.collection('article').doc(this.article.id).update({viewers,views})
        }
      }).catch(err => {
        console.log(err);
      })
    }
    else{
      const doc = (await firebase.collection('article').doc(this.article.id).get())
        if(doc){
          let viewers = doc.data().viewers || []
          viewers = viewers.filter(I => I !== firebase.auth().currentUser.id)
          viewers.push(firebase.auth().currentUser.id)
          let views = viewers.length
          firebase.collection('article').doc(this.article.id).update({viewers,views})
        }
    }
    // const messaging = await firebase.messaging() 
    // messaging.requestPermission().then(async() =>{
    //   this.token = await messaging.getToken()
    // })
  },
  async created(){
    // console.log('user #########',this.token)
    this.youhealthful = "https://youhealthful.com/article/"
    await firebase.firestore().collection('article').onSnapshot({ includeMetadataChanges: true },async () => {
    const articleFound = await firebase.firestore().collection("article").where("id", "==", this.$route.params.id).get({source: 'cache'})
    
    articleFound.forEach(doc => {
      this.article.title  = doc.data().title
      this.article.body = doc.data().body
      this.article.url = doc.data().url
      this.article.views =  doc.data().views ? doc.data().views : 0
      this.article.viewers =  doc.data().viewers,
      this.article.uri =  doc.data().uri,
      this.article.image =  doc.data().image ? doc.data().image : "",
      this.article.sourceTitle =  doc.data().sourceTitle,
      this.article.sourceUri =  doc.data().sourceUri,
      this.article.date =  doc.data().date,
      this.article.lang =  doc.data().lang,
      this.article.authors =  doc.data().authors ?  doc.data().authors : []
      })

      if(this.article.date.seconds){
        this.article.date = new Date(this.article.date.seconds*1000)
      }
      if(this.article.date.milliseconds){
        this.article.date = await new Date(this.article.date.milliseconds*1000000)
      }
      else{
        this.date = await new Date(this.article.date)
        this.date = this.date.toString().slice(0,21)
      }
      document.title += this.article.title
      this.title = this.article.title
    //   const messaging = await firebase.messaging() 
    //   messaging.requestPermission().then(async() =>{
    //   this.token = await messaging.getToken()
    // })
      this.id = this.article.uri
      this.paragraphs = this.article.body.split("\n")      
     })
      setTimeout(async() => { 
        // console.log('viewers : ',this.article.viewers) 
        this.article.viewers.find((ele) => {
        // if(ele === this.user){
        if(ele === this.token){
          this.tokenFound = true
          // console.log('foundd')
          }
        })
        if(!this.tokenFound) {
          // console.log('not found')
        this.article.viewers.push(this.token)
        // this.article.viewers.push(this.user)
        // console.log('viewers : ',this.article.viewers) 
        // console.log('article views',this.article.views)
        const updateViews = {
          title: this.article.title,
          body: this.article.body,
          url: this.article.url,
          views: this.article.views + 1,
          viewers: this.article.viewers,
          uri: this.article.uri,
          image: this.article.image ? this.article.image : "",
          sourceTitle: this.article.sourceTitle,
          sourceUri: this.article.sourceUri,
          date: this.article.date,
          lang: this.article.lang,
          authors: this.article.authors ? this.article.authors : []
      }
      // console.log('updateViews',updateViews.views)
      // console.log('updateViews',updateViews.viewers)
      // console.log('idd from query param',this.$route.params.id)
      await this.doUpdate({id:this.$route.params.id,values:updateViews})
      }
      this.views = true
      },1000)
      
}
}
